import PropTypes from 'prop-types';
import React from 'react';
import Edit from './edit';
import View from './view';

const Experience = ({ edit,reloadCandidateUpdatedAtData, ...props }) =>
  edit ? <Edit reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData}   {...props} /> : <View {...props} />;

  Experience.defaultProps = {
  edit: false,
};

Experience.propTypes = {
  edit: PropTypes.bool,
};

export default Experience;
